import type { ReactNode } from "react";

import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import type { SxProps } from "@mui/material/styles";

import CircularProgress from "components/circular-progress";

import TypingIndicator from "./typing-indicator";

type WordProcessorLoadingSkeletonProps = {
  value: string | null | undefined;
  /** Rendered in place of `value` when given: for a blocked-state notice that carries a link. */
  content?: ReactNode;
  height: number | undefined;
  isLoading?: boolean;
  sx?: SxProps;
};

export default function WordProcessorLoadingSkeleton({
  value,
  content,
  height = 400,
  isLoading = true,
  sx
}: WordProcessorLoadingSkeletonProps) {
  return (
    <Box
      sx={{
        height: height ? `${height - 30}px` : undefined,
        border: `solid 2px ${grey[200]}`,
        paddingLeft: "18px",
        borderRadius: "8px",
        userSelect: "none",
        width: "calc(100% - 20px)",
        overflow: "hidden",
        position: "relative",
        ...sx
      }}
    >
      <Box
        sx={{
          overflowY: "auto",
          height: "calc(100% - 20px)",
          paddingRight: "18px",
          paddingTop: 2
        }}
      >
        {content ? (
          <Box
            className="tiny-cloud-html"
            sx={{ width: "100%", color: "text.secondary", display: "inline" }}
          >
            {content}
          </Box>
        ) : (
          <Box
            className="tiny-cloud-html"
            sx={{
              wordBreak: "break-all",
              width: "100%",
              opacity: 0.5,
              display: "inline"
            }}
            dangerouslySetInnerHTML={{ __html: value || "" }}
          />
        )}

        {isLoading && (
          <Box
            component="span"
            sx={{ color: "#666", fontSize: "14px", marginLeft: "2px" }}
          >
            <TypingIndicator />
          </Box>
        )}
        {isLoading && (
          <Box sx={{ transform: "translateY(-50px)" }}>
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  );
}
